<template>
  <div :id="domid" :style="{ width: width, height: height }"></div>
</template>

<script>
import * as echarts from "echarts"; // 导入echarts
import elementResizeDetectorMaker from "element-resize-detector";
const erd = elementResizeDetectorMaker();
export default {
  props: {
    domid: {
      type: String,
      require: true,
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    option: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  watch: {
    option: {
      handler(newV, oldV) {
        if (JSON.stringify(newV) !== "{}") {
          this.myChart.setOption(this.option);
        }
      },
      deep: true,
    },
  },
  destroyed() {
    erd.uninstall(document.getElementById(this.domid));
  },
  mounted() {
    this.myChart = echarts.init(document.getElementById(this.domid));
    this.myChart.setOption(this.option);
    erd.listenTo(document.getElementById(this.domid), () => {
      this.$nextTick(() => {
        if (this.myChart) {
          console.log("使echarts尺寸重置");
          this.myChart.resize();
        }
      });
    });
  },
};
</script>